export type TransformNavDataType = {
  date: string;
  closing: number;
  redemption: number;
  subscription: string;
  units: string;
  isin: string;
};

function transformNav(data: TransformNavDataType) {
  const {
    date: navDateOfEvent,
    closing: closing,
    redemption: priceOfRedemptionNav,
    subscription: subscription,
    units: units,
    isin: isin,
  } = data;

  return {
    isin,
    priceOfRedemptionNav,
    navDateOfEvent,
    closing,
    subscription,
    units,
  };
}

export { transformNav };
